import { useMutation } from '@tanstack/react-query';
import { POST } from '../../../../services';
import { openAlert } from '../../../../components/alert/useAlert';

const POST_SEND_REMARK = `/warranty/abm/api/v2/admin/claims/update/remark`;

export const useSendRemark = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const response = await POST(POST_SEND_REMARK, payload);
      return response;
    },
    onSuccess: () => {
      openAlert({ model: 'message', type: 'success', message: 'ส่งข้อความหมายเหตุสำเร็จ' });
    },
  });
};
